var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleExclamationMark = function SvgCircleExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "circle-exclamation-mark_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circle-exclamation-mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "M12 16.725a.78.78 0 0 0 .575-.225.78.78 0 0 0 .225-.575.78.78 0 0 0-.225-.575.78.78 0 0 0-.575-.225.78.78 0 0 0-.575.225.78.78 0 0 0-.225.575q0 .35.225.575t.575.225m-.75-3.65h1.5v-6h-1.5zM12 21.5a9.3 9.3 0 0 1-3.712-.75 9.6 9.6 0 0 1-3.013-2.025 9.6 9.6 0 0 1-2.025-3.013A9.3 9.3 0 0 1 2.5 12q0-1.975.75-3.713a9.6 9.6 0 0 1 2.025-3.012A9.6 9.6 0 0 1 8.288 3.25 9.3 9.3 0 0 1 12 2.5a9.3 9.3 0 0 1 3.713.75 9.6 9.6 0 0 1 3.012 2.025 9.6 9.6 0 0 1 2.025 3.012A9.3 9.3 0 0 1 21.5 12q0 1.975-.75 3.712a9.6 9.6 0 0 1-2.025 3.013 9.6 9.6 0 0 1-3.012 2.025A9.3 9.3 0 0 1 12 21.5m0-1.5q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
  }))));
};
export default SvgCircleExclamationMark;